/**
 * Get the default timezone of the user's environment.
 *
 * @returns {string} The default timezone, or "UTC" if it cannot be determined.
 */
export default function defaultTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}
